// extracted by mini-css-extract-plugin
export default {"Lifecycle":"_Lifecycle--s5sai"};